import theme from '../../styles/themes/default.theme'

/** Matches RadioCardGroup.component.design.pen: padding 20, gap 16, radio 20/10, vertical group gap 12. Radius/width toned down for form context. */
const CARD_PADDING = theme.spacing(2.5) // 20
const CARD_GAP = theme.spacing(2) // 16
const RADIO_SIZE = 20
const RADIO_DOT_SIZE = 10
const GROUP_GAP = theme.spacing(1.5) // 12
const TEXT_BLOCK_GAP = theme.spacing(0.5) // 4

const styles = {
  group: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: GROUP_GAP,
    width: '100%',
    maxWidth: 420,
    flexWrap: 'wrap' as const
  },

  card: {
    display: 'flex',
    alignItems: 'center',
    gap: CARD_GAP,
    padding: CARD_PADDING,
    borderRadius: theme.shape.borderRadius / 4,
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${theme.palette.grey[300]}`,
    cursor: 'pointer',
    height: '100%',
    minHeight: 80,
    transition: theme.transitions.create(['border-color', 'box-shadow', 'background-color'], {
      duration: theme.transitions.duration.short
    }),
    '&:hover': {
      borderColor: theme.palette.grey[400]
    }
  },

  cardSelected: {
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.tertiary?.main ?? '#F5F3FF',
    '&:hover': {
      borderColor: theme.palette.primary.main
    }
  },

  cardDisabled: {
    backgroundColor: theme.palette.grey[100],
    cursor: 'not-allowed',
    borderColor: theme.palette.grey[300],
    '&:hover': {
      borderColor: theme.palette.grey[300]
    }
  },

  radioOuter: {
    width: RADIO_SIZE,
    height: RADIO_SIZE,
    borderRadius: '50%',
    border: `2px solid ${theme.palette.grey[400]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },

  radioOuterSelected: {
    borderColor: theme.palette.primary.main
  },

  radioOuterDisabled: {
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[100]
  },

  radioDot: {
    width: RADIO_DOT_SIZE,
    height: RADIO_DOT_SIZE,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main
  },

  textBlock: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: TEXT_BLOCK_GAP,
    minWidth: 0,
    flex: 1
  },

  title: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.3
  },

  titleDisabled: {
    color: theme.palette.text.disabled
  },

  description: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.text.secondary,
    lineHeight: 1.3
  },

  descriptionDisabled: {
    color: theme.palette.text.disabled
  },

  inputSlot: {
    marginTop: theme.spacing(1)
  },

  /** Visually hidden MUI Radio for accessibility */
  hiddenRadio: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap' as const,
    border: 0
  }
}

export default styles
